














import { Component, Vue } from "vue-property-decorator"
import UserProfileGeneral from "./User/UserProfileGeneral.vue"
import UserProfileChangePassword from "./User/UserProfileChangePassword.vue"

@Component({
  components: {
    UserProfileGeneral,
    UserProfileChangePassword
  },
})
export default class UserProfile extends Vue {
  sidebarItems = [
    {
      title: "General"
    },
    {
      title: "Change Password"
    },
  ]

  sidebarIndex = 0
}
